import { z } from '@/libs/zod';
import { FaqTarget } from '@/types/enums';

export const faqSchema = z.object({
  id: z.number(),
  title: z.string(),
  description: z.string(),
  target: z.enum([FaqTarget.MANAGER, FaqTarget.AFFILIATE, FaqTarget.CUSTOMER]),
  createdAt: z
    .union([z.string(), z.date()])
    .transform((date) => (typeof date === 'string' ? new Date(date) : date)),
  updatedAt: z
    .union([z.string(), z.date()])
    .transform((date) => (typeof date === 'string' ? new Date(date) : date)),
});

export type Faq = z.infer<typeof faqSchema>;
